import React from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { goTo } from "../tools";
import { callService } from '../tools';
import TextField from 'material-ui/TextField';
import firebase from 'firebase';
import regeneratorRuntime from "regenerator-runtime";
import gnpVideos from "./CargaMasiva.css";
import estilosOlv from "../gnp-recuperar-contrasenia/estilos-olv.css";
import estilosRegistro from "../gnp-registro/gnp-registro.css";
import moment from "moment";
import { servicios } from './../properties';
import closeIcon from '../img/close-icono.png';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
const modalEnvio = "#modal-nuevo-bloqueado";
const palabraError = "error";
const palabraOcurrioError = "Ocurrio Un error";
const palabraExito = "exito";
var action ="false";
const mapState = (state) => {
    return {
        dispositivo: state.global.dispositivo
    };
}


const mapDispatch = (dispatch) => {
    return {
        loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		}
    }
}

const campoSettingsCM = {
	fontFamily: 'Open Sans',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettingsCM = {
	...campoSettingsCM,
	lineHeight: '17px',
	color: '#567099',
	letterSpacing: '0.6px',
}

const floatingLabelFocusStyleSettingsCM = {
	...campoSettingsCM,
	lineHeight: '17px',
	color: '#FF6B0B',
	letterSpacing: '0.6px',
}

const campo = ({ input, label, max, type, focus, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				fullWidth={true}
				floatingLabelText={label}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				type={type}
				floatingLabelStyle={floatingLabelStyleSettingsCM}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettingsCM}
				onFocus={focus}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				maxLength={max}
				errorText={touched && error}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
};

class CargaMasiva extends React.Component {
    state = {
        archivoCargaMasiva: {},
        nombreArchivo : "",
        showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
        inputType: "",
        txtAccion: "REGISTRO MASIVO SOY CLIENTE"
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

    changeInputFile = (event) => {
        const reader = new FileReader();
        const file = event.target.files[0];
        const nombreArchivo = file.name;
        console.log(nombreArchivo);
        reader.onloadend = () => {
            this.setState({archivoCargaMasiva: file});
            this.setState({nombreArchivo: nombreArchivo});
            this.nameFile = this.state.nombreArchivo;
            $(modalEnvio).modal({ backdrop: "static", keyboard: true });
        }
        reader.readAsDataURL(file);
        console.log('file',file);
    }

    save = () => {
        var contadorLlamadas = 0;
        const fechaActual = moment(new Date()).format("YYYYMMDDHHmmss");
        const nombreArchivo= fechaActual + '.csv';
        console.log(nombreArchivo);
        var storageRef = firebase.storage().ref('documentos/' + 'documentosExcel' + '/');
        var uploadTaskIfe = storageRef.child(nombreArchivo).put(this.state.archivoCargaMasiva);
        uploadTaskIfe.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            contadorLlamadas++;
            console.log(contadorLlamadas);
            this.cerrarModal();
            if(contadorLlamadas<=1){
                console.log('segunda llamada');
                this.registroCargaMasiva(fechaActual);
            }else{
                console.log('segunda llamada');
            }
        },
        (err) => {
            console.log('aqui el error');
            this.muestraTooltip(true, palabraError, palabraOcurrioError, "No fue posible realizar la carga, favor de validar el archivo.");
        });
    }

    consultaEjemplo = (tipo) => {
        
            this.props.loader(true);
            const fecha = document.getElementsByName("fechaPoliza")[0].value;
        
            var nombreArchivoFinal = "";
            if(tipo === 'ejemplo') {
                nombreArchivoFinal = "ejemploCargaMasiva.csv";
            }else {
                nombreArchivoFinal = moment(fecha).format("YYYYMMDD") +'_ResultadoFinal'+'.xlsx';
            }
            console.log('archivo final', nombreArchivoFinal);
            firebase.storage().ref('documentos/' + 'documentosExcel' + '/' + nombreArchivoFinal)
            .getDownloadURL().then(oValue => {
                console.log(oValue);
                this.props.loader(false);
                fetch(oValue)
                    .then(response => response.blob())
                    .then(blob => {
                        const link = document.createElement("a");
                        link.href = URL.createObjectURL(blob);
                        link.download = nombreArchivoFinal;
                        link.click();
                }).catch(error1 => {
                    this.props.loader(false);
                    console.log("Error al descargar1: ", error1);
                    this.muestraTooltip(true, palabraError, palabraOcurrioError, "No se encontró ningún archivo con la fecha seleccionada.");
                });
                console.log("Lo descargué");
            }).catch(error => {
                this.props.loader(false);
                console.log("Error al descargar: ", error);
                this.muestraTooltip(true, palabraError, palabraOcurrioError, "No se encontró ningún archivo con la fecha seleccionada.");
            });         
        }

    registroCargaMasiva = (nombreArchivo) => {
        console.log('nombre una',nombreArchivo, action);
        this.props.loader(true);
        setTimeout(() => {
            new callService({
                service: "registro.registroCargaMasiva",
                secure: false,
                data: {"nombreArchivo": nombreArchivo, "consulta": action}
            }).execute().then((respuesta) => {
                console.log(respuesta);
                this.muestraTooltip(true, palabraExito, "Exito", "El archivo fue cargado con éxito.");
                this.props.loader(false);
            }).catch((error) => {
                console.log(error);
                this.props.loader(false);
                this.muestraTooltip(true, palabraError, palabraOcurrioError, "Ocurrio un error en la funcion del CRON");
            });
        }, 4000);
    }

    regresar = () => {
        firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
            var data = oValue.val();
            if(!data){
                goTo("mi-perfil");
            }else {
                window.location.href = servicios.dominioReingenieria+"login";
            }
        })
    }

    cerrarModal = () => {
        this.setState({nombreArchivo: ""});
        this.setState({archivoCargaMasiva: {}});
		$(modalEnvio).modal('hide');
	}

    
	onFocusFecha = (event) => {
        console.log('onfocus fecha');
		this.setState({ inputType: 'date' });
		var diaHoy = event.currentTarget.value.substr(8, 9);
		var mesHoy = event.currentTarget.value.substr(5, 2);
		var anioHoy = event.currentTarget.value.substr(0, 4);
		document.getElementsByName("fechaPoliza")[0].value = diaHoy + "/" + mesHoy + "/" + anioHoy;
	}

    onBlurFecha = () => {
		console.log('oblur fecha')
		this.setState({ inputType: 'text' });
		if (document.getElementsByName("fechaPoliza")[0].value.includes("-")) {
			this.setState({ inputType: 'date' });
		}
	}

    checkAction = (valor)=> {
        action = valor;
        console.log(action);
        if(action === "true"){
            this.setState({txtAccion: "Consulta carga masiva"})
        }else {
            this.setState({txtAccion: "Registro masivo Soy Cliente"})
        }
    }

    render() {
        return <div style={{height:'100vh'}}>
            <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
			</ModalSintillo>
            <div className="txt-center" style={{padding:'0px 28px',paddingTop:'24px'}}>
                <div id="title-Registro" style={{marginTop:'0px'}}>
                    <span className="material-icons bi bi-arrow-left" 
                    style={{float: "left", cursor: "pointer", marginTop: "20px"}} onClick={this.regresar}>
                        arrow_back
                    </span>
                    <label id="txt-Registro">Registro Masivo</label>
                    <br />
                    <hr className="label-hr" />
                </div>
                <div className="row" style={{marginTop:'62px', textAlign:'center'}}>
                    <div className='col-md-12' style={{display:"flex", justifyContent:"center", marginBottom:'32px'}}>
                        <div style={{marginRight:"8px"}}>
                            <button className={action === "false" ? "btnActive" : "btnNormal"} 
                            onClick={()=> this.checkAction("false")} >
                                Carga masiva</button>
                        </div> 
                        <div>
                            <button className={action === "true" ? "btnActive" : "btnNormal"} 
                            onClick={()=> this.checkAction("true")}  >
                                Consulta bitácora</button>
                        </div>
                    </div>

                {action ==='false' ? <div className='col-md-12' style={{marginBottom:'16px'}}>
                        <label className='cargaMasivaTitulo'>Adjunte layout de carga como el siguiente:  
                        <a onClick={this.consultaEjemplo.bind(this,'ejemplo')}> <u>Ejemplo</u></a></label>
                    </div> : <div></div> }
                        
                   
                    <div className='col-md-12' style={{display:"flex", justifyContent:"center"}}>
                        <div className='col-md-7' id="datos-fiscales-form" style={{textAlign:'start'}}>
                            <label className='cargaMasivaSubTitulo'>{this.state.txtAccion}</label>
                                <div className="styles" id="archivo" style={{marginTop:'8px'}}>
                                    <label className="custom-file-upload agregarArchivo" id="agregarArchivo"    >
                                        <div id="attachment"><i className="center-icon"> 
                                        <img className="imgArchivoCM" src={require("../img/icon_add_naranja.png")} /></i> </div>
                                        <input   accept=".csv" id="inputFileId"
                                            onChange={this.changeInputFile}
                                            type="file" id="fileLicencia" 
                                            style={{ display: "none" }} /> <i /> Agregar archivo </label>
                                </div>
                        </div>
                    </div>
                    <div className='col-md-12' style={{marginTop:'40px'}}>
                        {action === "false" ? 
                        <label className='cargaMasivaTitulo'>Consulta tu bitácora de registros fallidos o exitosos</label> :
                        <label className='cargaMasivaTitulo'>Consulta tu bitácora de registros concluidos</label> }
                    </div>            
                    <div className="col-md-12" style={{display:"flex", justifyContent:"center"}}>
                        <div className='col-md-5'>
                            <div id="fecha-vigencia" style={{marginTop:'16px'}}>
                                <Field
                                    name="fechaPoliza" type={this.state.inputType}
                                    id="fechaPoliza" max="10"
                                    component={campo} id="fecha-vigencia-poliza"
                                    label="Fecha del reporte de bitácora"
                                    onBlur={this.onBlurFecha.bind(this)}
                                    focus={this.onFocusFecha.bind(this)}/>
                            </div>
                        </div>
                    </div> 
                    <div className="col-md-12" style={{display:"flex", justifyContent:"center"}}>
                        <div className='col-md-7'>
                            <button type="button" onClick={this.consultaEjemplo.bind(this,'consultaFecha')}
                                id="btnAceptarAviso" style={{height:"40px", width:"118px"}} 
                                className="orange-rectangle btn">Consultar</button>
                        </div>
                    </div>
                </div>
                <div className="modal modal-msj fade" id="modal-nuevo-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel"
                    data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ width:'90%', margin:'24px'}}>
                            <div style={{width:'100%'}}>
                                <img src={closeIcon} style={{position:'absolute', top:'0', right:'0' }} 
                                id="icon-close" onClick={this.cerrarModal} />
                            </div>
                            <div className="modal-cabecera" style={{textAlign:'center', marginTop:'24px'}}>

                                <label className="cargaMasivaTituloModal" id="modal-nuevo-bloqueadoLabel">Adjunta archivo</label>
                            </div>
                            <div style={{textAlign:'center'}}>
                                <p className="cargaMasivaSubTituloModal">Archivo seleccionado: {this.state.nombreArchivo} </p>
                            </div>
                            <div className="text-center aceptar-cancelar-btn mt-20 opciones-bloqueo" style={{width:'270px', height:'31px'}}>
                                <button type="button" className="btn orange-btn-large" 
                                style={{position:'absolute',left:'24px', width:'113px', bottom:'15px'}}
                                onClick={this.save}>Enviar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}
CargaMasiva = reduxForm({ form: "datosSeguridad" })(CargaMasiva);
export default connect(mapState, mapDispatch)(CargaMasiva);



// WEBPACK FOOTER //
// ./src/gnp-carga-masiva/CargaMasiva.frm.js